import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import "assets/styles.css";

function formatNetChange(value) {
  if (value == null || Number.isNaN(value)) {
    return { text: "N/A", className: "neutral" };
  }

  if (value > 0) {
    return { text: `▲ Net Change +${value} pts`, className: "positive" };
  }

  if (value < 0) {
    return { text: `▼ Net Change ${value} pts`, className: "negative" };
  }

  return { text: "Net Change 0 pts", className: "neutral" };
}

function formatRankChange(value) {
  if (value == null || Number.isNaN(value)) {
    return { text: "N/A", className: "neutral" };
  }

  if (value > 0) {
    const label = value === 1 ? "rank" : "ranks";
    return { text: `+${value} ${label}`, className: "positive" };
  }

  if (value < 0) {
    const absValue = Math.abs(value);
    const label = absValue === 1 ? "rank" : "ranks";
    return { text: `-${absValue} ${label}`, className: "negative" };
  }

  return { text: "Rank unchanged", className: "neutral" };
}

export default function HistoricalInfoBoxes({ netWrChange, rankChange }) {
  const netChange = formatNetChange(netWrChange);
  const rankChangeDisplay = formatRankChange(rankChange);

  return (
    <Box className="TDHistoricalInfoBoxes">
      <Box className={`TDHistoricalInfoBox ${netChange.className}`}>
        {netChange.text}
      </Box>
      <Box className={`TDHistoricalInfoBox ${rankChangeDisplay.className}`}>
        {rankChangeDisplay.text}
      </Box>
    </Box>
  );
}

HistoricalInfoBoxes.propTypes = {
  netWrChange: PropTypes.number,
  rankChange: PropTypes.number,
};

HistoricalInfoBoxes.defaultProps = {
  netWrChange: null,
  rankChange: null,
};
